import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const config = {
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
};
const CURRENT_PROFILE_KEY = "userProfile";
export class UserApi {
  static logoutUser() {
    const url = `${BASE_URL}/authenticate/logout`;

    return axios.get(url, config);
  }
  static getAllUsers(id) {
    const url = `${BASE_URL}/organization/${id}/users/list`;

    return axios.get(url, config);
  }
  static getOrgOwners(id) {
    const url = `${BASE_URL}/organization/${id}/owners`;

    return axios.get(url, config);
  }
  static getUser(id, orgId) {
    const url = `${BASE_URL}/user/${orgId}/${id}`;
    return axios.get(url, config);
  }
  static getPortalAccessDetails(params) {
    const url = `${BASE_URL}/organization/sessions`;
    return axios.post(url, params, config);
  }
  static getOrgBadgeAccessLogs(params) {
    const url = `${BASE_URL}/organization/accesspoints`;
    return axios.post(url, params, config);
  }
  static getOrgDataCenterAccess(id, userId) {
    const url = `${BASE_URL}/organization/accesslogs/${id}/${userId}`;
    return axios.get(url, config);
  }

  static updateEulaStatus(params) {
    const url = `${BASE_URL}/eula/status`;

    return axios.post(url, params, config);
  }
  static getEulaVersion() {
    const url = `${BASE_URL}/eula/version`;

    return axios.get(url, config);
  }
  static getEula = (url) => {
    return axios.get(url, config);
  };

  static getRosterSummary(id) {
    const url = `${BASE_URL}/organization/${id}/roster/summary`;

    return axios.get(url, config);
  }
  static resetUserPassword(email) {
    const url = `${BASE_URL}/user/forgotpassword`;
    const params = {
      userName: email,
    };

    return axios.post(url, params);
  }
  static saveUserProfileImageRequest(blob) {
    const url = `${BASE_URL}/user/customimage`;
    const formData = new FormData();
    const config = {
      withCredentials: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };
    formData.append("file", blob);
    return axios.post(url, formData, config);
  }
  static deleteUserProfileImageRequest() {
    const url = `${BASE_URL}/user/customimage/delete`;

    return axios.get(url, config);
  }

  static addNewPortalUser = (params) => {
    const url = `${BASE_URL}/user/`;

    return axios.post(url, params, config);
  };

  static getAlert = () => {
    const url = `${BASE_URL}/operations/alert`;

    return axios.get(url, config);
  };

  static updateMFA = (params) => {
    const url = `${BASE_URL}/user/mfa`;

    return axios.put(url, params, config);
  };
}

export const saveUserProfile = (profile) => {
  try {
    sessionStorage.setItem(CURRENT_PROFILE_KEY, JSON.stringify(profile));
  } catch (e) {
    console.log(e);
    return false;
  }

  return true;
};

export const getUserProfile = () => {
  let currentMembership;
  try {
    currentMembership = JSON.parse(sessionStorage.getItem(CURRENT_PROFILE_KEY));
  } catch (e) {
    console.log(e);
    return null;
  }

  return currentMembership;
};

export const deleteUserProfile = () => {
  let currentMembership;
  try {
    currentMembership = JSON.parse(
      sessionStorage.removeItem(CURRENT_PROFILE_KEY)
    );
  } catch (e) {
    console.log(e);
    return null;
  }

  return currentMembership;
};

export const setUserPermissions = (moduleName, permissions) => {
  try {
    sessionStorage.setItem(
      `${moduleName}Permissions`,
      JSON.stringify(permissions)
    );
  } catch (e) {
    console.log(e);
    return false;
  }

  return true;
};

export const getUserPermissions = (moduleName) => {
  let currentMembership;
  try {
    currentMembership = JSON.parse(
      sessionStorage.getItem(`${moduleName}Permissions`)
    );
  } catch (e) {
    console.log(e);
    return null;
  }

  return currentMembership;
};
